// extracted by mini-css-extract-plugin
export var active = "TagLink-module--active--99d83";
export var component = "TagLink-module--component--62ad0";
export var fadePop = "TagLink-module--fade-pop--dfee6";
export var growHeightIn = "TagLink-module--grow-height-in--7e6a7";
export var text = "TagLink-module--text--2ab17";